export default Object.freeze({
    Primary: 'Primary',
    Secondary: 'Secondary',
    Error: 'Error',
})